<template>
    <div class="message-delay-input">
        <div class="delay-input-area">
            <span class="material-icons delay-input-icon">timer</span>
            <input type="text" v-model="mirrorValue" class="delay-input" />
        </div>
    </div>
</template>
<script>
export default {
    name: "MessageDelayInput",
    props: {
        value: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            mirrorValue: this.value,
            previousValue: this.value,
            timeoutId: null,
        };
    },
    watch: {
        value(val) {
            this.mirrorValue = val;
            this.previousValue = val;
        },
        mirrorValue(val) {
            if (val === "" || val === null) {
                this.mirrorValue = 0;
            } else if (isNaN(val)) {
                this.mirrorValue = this.previousValue;
                this.$message.error(this.$t("message.dealyTimeTypeError"));
            } else if (val > 15) {
                this.mirrorValue = 15;
                this.$message.error(this.$t("message.dealyTimeMaxValueError"));
            } else {
                if (this.timeoutId) {
                    clearTimeout(this.timeoutId);
                }

                this.timeoutId = setTimeout(() => {
                    this.$emit("input", val);
                }, 1000);
            }
        },
    },
};
</script>
<style>
.message-delay-input {
    width: 15%;
    .delay-input-area {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #f5f5f5;
        border-radius: 0.5rem;
        border: 1px solid #e0e0e0;
        gap: -5px;
        .delay-input-icon {
            position: absolute;
            left: 0;
            font-size: 1.5rem;
        }
        .delay-input {
            width: 80%;
            border: none;
            background-color: transparent;
            font-size: 1rem;
            text-align: center;
        }
    }
}
</style>
